<!--
 * @Author: shiao
 * @Date: 2020-11-23 13:47:22
 * @LastEditTime: 2021-01-15 17:26:53
 * @LastEditors: shiao
 * @Description: 通用弹窗
 * @FilePath: \health-app\src\components\oil-pup.vue
-->
<template>
  <div class="oil-pup-div" v-show="show" :style="{'z-index':Zindex}">
    <div class="oil-pup-mask" @touchmove.prevent>
      <div class="oil-pup-item">
        <div class="oil-pup-title" v-if="title">{{title}}</div>
        <div class="oil-pup-icon" v-if="pupicon"> <img :src="pupicon" alt=""></div>
        <div class="oil-pup-content" v-if="content">{{ content }}</div>
        <div><slot name="pup-center"></slot></div>
        <div class="oil-pup-btn" :style="{'justify-content': pupcancelText && pupcertainText ?'space-between': 'center'}">
          <div v-if="pupcancelText" :class=" cancelbtnactiavte ? 'cancel-btn btn-actiavte': 'cancel-btn' " @click="pupcancel" :style="{'color':pupcancelColor}">{{pupcancelText}}</div>
          <div v-if="pupcertainText" :class=" certainbtnactiavte ? 'certain-btn btn-actiavte': 'certain-btn'" @click="pupcertain" :style="{'color':pupcertainColor}">{{pupcertainText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default:'',
      },
      show: {
        type: Boolean,
        required: true,
      },
      pupcancelText: {
        type: String,
        default: '取消'
      },
      pupcertainText: {
        type: String,
        default: '呼叫'
      },
      Zindex: {
        type: Number,
        default: 999
      },
      pupcancelColor: {
        type: String,
        default: '#999999;'
      },
      pupcertainColor: {
        type: String,
        default: '#f9591b;'
      },
      cancelbtnactiavte: {
        type: Boolean,
        required: false,
      },
      certainbtnactiavte: {
        type: Boolean,
        required: false,
      },
      pupicon: {
        type: String,
        default: ''
      }
    },
    methods: {
      pupcancel() {
        this.$emit('cancel', false)
      },
      pupcertain() {
        this.$emit('certain', false)
      },
    }
  }
</script>

<style lang="less" scoped>
  .oil-pup-div {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    width: 100%;

    .oil-pup-mask {
      background-color: rgba(000, 000, 000, 0.7);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .oil-pup-item {
      background-color: #ffffff;
      width: calc(100% - 36px);
      background: #FFFFFF;
      border-radius: 8px;
      overflow: hidden;

      .oil-pup-title {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 22px;
        letter-spacing: 0.52px;
        margin: 31px 0 47px;
      }

      .oil-pup-icon {
        width: 64px;
        height: 64px;
        margin: 0 auto 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .oil-pup-content {
        min-height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-align: center;
        padding: 0 38px;
        margin-bottom: 20px;
      }

      .oil-pup-btn {
        display: flex;
        justify-content: space-between;

        .cancel-btn,
        .certain-btn {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          text-align: center;
          border-radius: 16px;
          flex: 1;
          text-align: center;
          padding: 18px 0;
        }

        .btn-actiavte {
          color: #FFFFFF;
          background: #2CD8AA;
        }
      }
    }
  }
</style>